module.exports = __webpack_public_path__ + "static/media/tinfo.90af7305.png";